/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PrintIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 24 22"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5.5,16.5 L2.5,16.5 C1.4,16.5 0.5,15.6 0.5,14.5 L0.5,8.5 C0.5,7.4 1.4,6.5 2.5,6.5 L21.5,6.5 C22.601,6.5 23.5,7.4 23.5,8.5 L23.5,14.5 C23.5,15.6 22.601,16.5 21.5,16.5 L18.5,16.5" />
      <polyline points="5.5 4.5 5.5 0.5 15.5 0.5 18.5 3.5 18.5 4.5" />
      <rect x="5.5" y="13.5" width="13" height="8" />
      <circle cx="3.5" cy="9.5" r="1" />
      <path d="M7.5,15.5 L16.5,15.5" />
      <path d="M7.5,17.5 L16.5,17.5" />
      <path d="M7.5,19.5 L16.5,19.5" />
      <polyline points="15.5 0.5 15.5 3.5 18.5 3.5" />
    </g>
  </svg>
);

export default PrintIcon;
